import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { getFormSectionsAndFields } from "../../Utils/AllPagesQuriesAndMutations";

const useFetchFormFields = (props: { Form_Key: string; TypeOfPortal?: string; setInputFields?: (data: any) => void; }) => {

  const { Form_Key, TypeOfPortal, setInputFields } = props;

  const [getFormSectionAndFields, { loading, data, error, refetch }] = useLazyQuery(getFormSectionsAndFields, {
    variables: {
      key: Form_Key,
    },
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setInputFields(data?.formSectionAndFields);
    },
  });
  useEffect(() => {
    if (TypeOfPortal !== "Delete") {
      getFormSectionAndFields();
    }
  }, []);
  return {
    loading,
    data: data?.formSectionAndFields,
    error,
    getFormSectionAndFields,
    refetch
  };
};

export default useFetchFormFields;
